import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useState } from 'react';
import { IconRoot } from "./styles";
import { jsx as _jsx } from "react/jsx-runtime";
export var IconButton = function IconButton(_ref) {
  var onClick = _ref.onClick,
    ariaLabel = _ref.ariaLabel,
    hoverIcon = _ref.hoverIcon,
    smallerOnMobile = _ref.smallerOnMobile,
    testId = _ref.testId,
    children = _ref.children,
    className = _ref.className;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHovering = _useState2[0],
    setIsHovering = _useState2[1];
  var handleMouseOver = useCallback(function () {
    setIsHovering(true);
  }, []);
  var handleMouseOut = useCallback(function () {
    setIsHovering(false);
  }, []);
  return /*#__PURE__*/_jsx(IconRoot, {
    "aria-label": ariaLabel,
    className: className,
    color: "default",
    "data-testid": testId,
    smallerOnMobile: smallerOnMobile,
    variant: "contained",
    onClick: onClick,
    onMouseOver: handleMouseOver,
    onMouseOut: handleMouseOut,
    children: hoverIcon && isHovering ? hoverIcon : children
  });
};
//# sourceMappingURL=IconButton.js.map